import React from "react";
import Routes from "./router/Routes";

function App() {
  return <Routes />;
}

export default App;
